import posthog from 'posthog-js';
import { User } from 'components/User/types';
import { formatUserId } from './utils';
import { PosthogEvents } from './PosthogEvents';

interface TrackFilterParams {
  user: User | null;
  page: string;
  filterName: string;
  filterValue: string;
}

export function trackFilterList(params: TrackFilterParams) {
  const { user, page, filterName, filterValue } = params;

  if (user) {
    posthog.capture(PosthogEvents.FilterListClick, {
      action: 'Filtered List',
      page,
      filterName,
      filterValue,
      userId: user.id ? formatUserId(user.id) : undefined,
    });
  }
}
